import { render, staticRenderFns } from "./legalSubjectInfo.vue?vue&type=template&id=f82ab39e&scoped=true&"
import script from "./legalSubjectInfo.vue?vue&type=script&lang=js&"
export * from "./legalSubjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./legalSubjectInfo.vue?vue&type=style&index=0&id=f82ab39e&prod&scoped=true&lang=css&"
import style1 from "./legalSubjectInfo.vue?vue&type=style&index=1&id=f82ab39e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82ab39e",
  null
  
)

export default component.exports